import Vue from 'vue'
import Store from 'store'
import verifyLabel from '../../../methods/verifyLabel'


Vue.component('checkout-complete', {
    data() {
      return { 
        form: {
            conditions: false,
            newsletter: false
        }    
      }
    },
    props: {
        labels : Object
    },
    computed:{
        attemptedSubmit(){
            return Store.state.cart.attemptedSubmit
        },
        readytosubmit(){
            const formComplete = Store.state.cart.formComplete
            const conditionsAccepted = this.form.conditions
            return !!(conditionsAccepted && formComplete)
        },
        submitButton(){
            return !this.readytosubmit ? 'nti-button--not-ready' : ''
        },
        invalidCheckbox(){
            return this.attemptedSubmit && !this.form.conditions ? 'nti-checkbox--invalid' : ''
        },
        couponNotValidMessage() {
            return Store.state.cart.couponNotValidMessage
        },
        checkoutLabels() {
            if (Store.state.main.labels) {
                return Store.state.main.labels
            }
        }
    },
    methods: {
        submitNow(){
            Store.commit('cart/attemptSubmit')
            if (this.readytosubmit) {
                document.querySelector('#checkoutform').submit()
                //Show overlay with loader
                document.querySelector('div.nti-webshop-checkout__overlay').style.visibility = 'visible';
            }
        },
        discountInputInteraction(e) {
            const discountBtn = document.getElementById('coupon-discount-button');
            if(e.target.value != "") {
                if(discountBtn.firstElementChild != null) return;
                const css = "#coupon-discount-button { background-color: #006fb6 } #coupon-discount-button:hover { background-color: #00406a }";
                var style = document.createElement('style');

                if(style.styleSheet) style.styleSheet.cssRules = css;
                    else style.appendChild(document.createTextNode(css));

                discountBtn.appendChild(style);
            } else if(discountBtn.firstElementChild) { 
                discountBtn.removeChild(discountBtn.firstElementChild);
            }
        },
        applyCouponCode() {           
            const inputValue = document.getElementById('coupon-discount-input').value
            Store.dispatch("cart/checkCouponCode", inputValue)
        },
        verifyLabel(displayName) {
            if (Store.state.main.labels) {
                return verifyLabel(displayName,Store.state.main.labels)
            } else {
                return ""
            }
        }
    },
    watch: {
        form: {
            handler(){
                Store.dispatch('cart/conditionsAndPermissions',this.form)
            },
            deep: true
        }
    }
  });

new Vue({
    el: 'checkout-complete'
})

